// @ts-nocheck
import React, { useState, useRef, useEffect } from 'react'
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
  PDFViewer,
  PDFDownloadLink,
  pdf,
} from '@react-pdf/renderer'
import NoPicture from './no-picture-comparable.jpg'
import {} from '@react-pdf/renderer'
import $ from 'jquery'
import {
  age_comparate,
  bathrooms_comparate,
  bathrooms_compate,
  environment_comparate,
  getfavorites,
  parking_comparate,
  pool_comparate,
  prices_comparate,
  prices_comparate_alquiler,
  prices_comparate_temporario,
  prices_comparate_venta,
  roofed_comparate,
  room_comparate,
  semiroofed_comparate,
  surface_comparate,
  toilets_comparate,
  toilets_compate,
  total_comparate,
} from '@helpers/helper.favorites'
import {
  getAge,
  getBathrooms,
  getEnvironment,
  getFakeAddres,
  getLocation,
  getOperations,
  getPrices,
  getRooms,
  getToilets,
  hasBarbacue,
  hasPool,
  hasTag,
  makeLink,
} from '@helpers/helper.properties'
import FeaturedSVG from './featured.png'
import CheckPNG from './Vector-check.png'
import NonePNG from './Vector-none.png'

import { getCover, getPreviewSlider } from '@helpers/helper.rendering'
import Slideshow from './slideshow'
import {
  Separator,
  FeaturedTr,
  OperationTypeTr,
  PriceTrVenta,
  PriceTrAlquiler,
  ExpensesTr,
  RoofedSurfaceTr,
  SemiRoofedSurfaceTr,
  SurfaceTr,
  EnvironmentTr,
  RoomsTr,
  AgeTr,
  //   GarageTr,
  BarbacueTr,
  PoolTr,
  TotalSurfaceTr,
  PriceTrAlquilerTemp,
  ToiletsTr,
  BathroomsTr,
  TagTr,
} from './dataTable-render'
import { updateFavorites } from '@slices/propertiesSlice'

const type_environments = [
  { name: 'Balcón', id: 10 },
  { name: 'Terraza', id: 25 },
  { name: 'Jardín', id: 25 },
  { name: 'Baulera', id: 19 },
  { name: 'Oficina', id: 5 },
  { name: 'Lavadero', id: 20 },
]
const generals = [
  { name: 'Calefacción', id: 31 },
  { name: 'Aire Acondicionado individual', id: 28 },
  { name: 'Apto crédito', id: 1528 },
  { name: 'Solarium', id: 40 },
  { name: 'Apto mascotas', id: 46 },
  { name: 'Pileta', id: 51 },
  { name: 'Seguridad 24Hs', id: 1524 },
  { name: 'Gimnasio', id: 33 },
  { name: 'SUM', id: 41 },
  { name: 'Apto profesional', id: 47 },
]
const services = [
  { name: 'Agua Corriente', id: 1 },
  { name: 'Cloaca', id: 2 },
  { name: 'Gas Natural', id: 3 },
  { name: 'Internet', id: 4 },
  { name: 'Electricidad', id: 5 },
  { name: 'Pavimento', id: 6 },
]

const DataTable = ({
  data,
  elI,
  elII,
  elIII,
  setElI,
  setElII,
  setElIII,
  global_data,
  update = false,
}) => {
  const refTypeI = useRef()
  const refTypeII = useRef()
  const refTypeIII = useRef()

  const favs = getfavorites('prop', 'template-site')

  const updatePropI = () =>
    setElI(data.find((element) => element.id.toString() === refTypeI?.current?.value.toString()))
  const updatePropII = () =>
    setElII(data.find((element) => element.id.toString() === refTypeII?.current?.value.toString()))
  const updatePropIII = () =>
    setElIII(
      data.find((element) => element.id.toString() === refTypeIII?.current?.value.toString()),
    )

  const [points, setPoints] = useState([0, 0, 0])

  // const [elI, setElI] = useState(null)
  // const [elII, setElII] = useState(null)
  // const [elIII, setElIII] = useState(null)

  const handleOpenPDF = async () => {
    const blob = await pdf(
      <PDF
        elI={elI}
        elII={elII}
        elIII={elIII}
        points={points}
        comparated={comparated}
        global_data={global_data}
      />,
    ).toBlob()
    const url = URL.createObjectURL(blob)
    window.open(url, '_blank')
  }

  const [comparated, setComparated] = useState({
    priceVenta: -1,
    priceAlquiler: -1,
    priceAlquilerTemp: -1,
    total: -1,
    roofed: -1,
    semiroofed: -1,
    surface: -1,
    environment: -1,
    room: -1,
    bathrooms: -1,
    toilets: -1,
    age: -1,
    parking: -1,
  })

  const comparator = () => {
    let properties = []

    if (elI !== null) {
      properties.push(elI)
    }
    if (elII !== null) {
      properties.push(elII)
    }
    if (elIII !== null) {
      properties.push(elIII)
    }

    let auxPoints = [0, 0, 0]
    if (elII?.id) {
      for (let i = 0; i < properties.length; i++) {
        if (
          parseInt(properties[i]?.roofed_surface) === comparated.roofed &&
          (properties[0]?.roofed_surface !== properties[1]?.roofed_surface ||
            properties[1]?.roofed_surface !== properties[2]?.roofed_surface)
        ) {
          auxPoints[i]++
        }
        if (
          comparated.semiroofed === parseInt(properties[i]?.semiroofed_surface) &&
          (properties[0]?.semiroofed_surface !== properties[1]?.semiroofed_surface ||
            properties[1]?.semiroofed_surface !== properties[2]?.semiroofed_surface)
        ) {
          auxPoints[i]++
        }
        if (
          comparated.surface === parseInt(properties[i]?.surface) &&
          (parseInt(properties[0]?.surface) !== comparated.surface ||
            parseInt(properties[1]?.surface) !== comparated.surface ||
            parseInt(properties[2]?.surface) !== comparated.surface)
        ) {
          auxPoints[i]++
        }
        if (
          comparated.total === parseInt(properties[i]?.total_surface) &&
          (parseInt(properties[0]?.total_surface) !== comparated.total ||
            parseInt(properties[1]?.total_surface) !== comparated.total ||
            parseInt(properties[2]?.total_surface) !== comparated.total)
        ) {
          auxPoints[i]++
        }
        if (
          comparated.environment === properties[i]?.room_amount &&
          (properties[0]?.room_amount !== comparated.environment ||
            properties[1]?.room_amount !== comparated.environment ||
            properties[2]?.room_amount !== comparated.environment)
        ) {
          auxPoints[i]++
        }
        if (
          comparated.room === properties[i]?.suite_amount &&
          (properties[0]?.suite_amount !== comparated.room ||
            properties[1]?.suite_amount !== comparated.room ||
            properties[2]?.suite_amount !== comparated.room)
        ) {
          auxPoints[i]++
        }
        if (
          comparated.bathrooms === properties[i]?.bathroom_amount &&
          (properties[0]?.bathroom_amount !== comparated.bathrooms ||
            properties[1]?.bathroom_amount !== comparated.bathrooms ||
            properties[2]?.bathroom_amount !== comparated.bathrooms)
        ) {
          auxPoints[i]++
        }
        if (
          comparated.toilets === properties[i]?.toilet_amount &&
          (properties[0]?.toilet_amount !== comparated.toilets ||
            properties[1]?.toilet_amount !== comparated.toilets ||
            properties[2]?.toilet_amount !== comparated.toilets)
        ) {
          auxPoints[i]++
        }
        if (
          comparated.priceVenta ===
          getPrices(properties[i]).find((element) => element?.type.toLowerCase() === 'venta')?.price
        ) {
          auxPoints[i]++
        }
        if (
          comparated.priceAlquiler ===
          getPrices(properties[i]).find((element) => element?.type.toLowerCase() === 'alquiler')
            ?.price
        ) {
          auxPoints[i]++
        }
        if (
          comparated.priceAlquilerTemp ===
          getPrices(properties[i]).find(
            (element) => element?.type.toLowerCase() === 'alquiler temporario',
          )?.price
        ) {
          auxPoints[i]++
        }
        // if (comparated.parking === properties[i]?.parking_lot_amount) {
        //   console.log('A la ' + i + ' le sumo cocheras')
        //   auxPoints[i]++
        // }
        if (
          comparated.age === properties[i]?.age &&
          (properties[0]?.age !== comparated.age ||
            properties[1]?.age !== comparated.age ||
            properties[2]?.age !== comparated.age)
        ) {
          auxPoints[i]++
        }
        // if (
        //   hasBarbacue(properties[i]) &&
        //   (!hasBarbacue(properties[0]) ||
        //     !hasBarbacue(properties[1]) ||
        //     !hasBarbacue(properties[2]))
        // ) {
        //   auxPoints[i]++
        // }
        // if(hasPool(properties[i]) && (!hasPool(properties[0]) || !hasPool(properties[1]) || !hasPool(properties[2]))){
        //     auxPoints[i]++;
        // }
        for (const service of services) {
          if (
            hasTag(properties[i], service.id) &&
            (!hasTag(properties[0], service.id) ||
              !hasTag(properties[1], service.id) ||
              !hasTag(properties[2], service.id))
          ) {
            auxPoints[i]++
          }
        }
        for (const environment of type_environments) {
          if (
            hasTag(properties[i], environment.id) &&
            (!hasTag(properties[0], environment.id) ||
              !hasTag(properties[1], environment.id) ||
              !hasTag(properties[2], environment.id))
          ) {
            auxPoints[i]++
          }
        }
        for (const general of generals) {
          if (
            hasTag(properties[i], general.id) &&
            (!hasTag(properties[0], general.id) ||
              !hasTag(properties[1], general.id) ||
              !hasTag(properties[2], general.id))
          ) {
            auxPoints[i]++
          }
        }
      }
    }
    setPoints(auxPoints)
    return points
  }

  useEffect(() => {
    setElI(null)
    setElII(null)
    setElIII(null)
  }, [data])

  useEffect(() => {
    if (elI?.id || elII?.id || elIII?.id) {
      setComparated({
        ...comparated,
        priceVenta: prices_comparate_venta('venta', [elI, elII, elIII]),
        priceAlquiler: prices_comparate_alquiler('alquiler', [elI, elII, elIII]),
        priceAlquilerTemp: prices_comparate_temporario('alquiler temporario', [elI, elII, elIII]),
        total: total_comparate([elI, elII, elIII]),
        roofed: roofed_comparate([elI, elII, elIII]),
        semiroofed: semiroofed_comparate([elI, elII, elIII]),
        surface: surface_comparate([elI, elII, elIII]),
        bathrooms: bathrooms_comparate([elI, elII, elIII]),
        toilets: toilets_comparate([elI, elII, elIII]),
        environment: environment_comparate([elI, elII, elIII]),
        room: room_comparate([elI, elII, elIII]),
        parking: parking_comparate([elI, elII, elIII]),
        age: age_comparate([elI, elII, elIII]),
      })
    }
    if (elI?.id && elII?.id) {
      $('#download-link').removeClass('d-none-opacity')
    }
    if (!elI?.id || !elII?.id) {
      $('#download-link').addClass('d-none-opacity')
    }
  }, [elI, elII, elIII])

  useEffect(() => {
    if (!elI?.id) {
      setElII(null)
      setElIII(null)
    }
  }, [elI])

  useEffect(() => {
    if (!elII?.id) {
      setElIII(null)
    }
  }, [elII])

  useEffect(() => {
    comparator()
  }, [comparated])

  useEffect(() => {
    if (screen.width > 992) {
      if (
        data.filter((fav) => favs.find((id: number) => id.toString() === fav.id.toString()))
          .length === 3
      ) {
        $('#updatePropI').prop('selectedIndex', 1)
        $('#updatePropII').prop('selectedIndex', 2)
        $('#updatePropIII').prop('selectedIndex', 3)
        updatePropIII()
        updatePropII()
        updatePropI()
      }
    }
    if (
      data.filter((fav) => favs.find((id: number) => id.toString() === fav.id.toString()))
        .length === 2
    ) {
      $('#updatePropI').prop('selectedIndex', 1)
      $('#updatePropII').prop('selectedIndex', 2)
      $('#updatePropIII').prop('selectedIndex', 0)
      updatePropI()
      updatePropII()
      updatePropIII()
    }
  }, [data, favs])

  return (
    <>
      <div className="d-none">
        <PDF
          elI={elI}
          elII={elII}
          elIII={elIII}
          points={points}
          comparated={comparated}
          global_data={global_data}
        />
      </div>
      <div
        id="data-table"
        className="table-wrapper"
      >
        <button
          style={{ fontSize: '1rem', color: '#1f1f1f', background: 'transparent', border: 'none' }}
          onClick={handleOpenPDF}
          className={
            'button-download d-flex justify-content-end ' +
            (elI?.id && elII?.id ? 'd-flex' : 'd-none')
          }
        >
          <i className="icon-download"></i> Descargar comparativo
        </button>
        <div className="table-responsive">
          <table className="table">
            {/* Thead */}
            <thead>
              <tr className="d-xs-table-row d-sm-none">
                <th
                  colSpan={2}
                  className="text-center first-cell py-3"
                >
                  Dirección
                </th>
              </tr>
              <tr>
                <th
                  scope="col"
                  className="d-none d-sm-table-cell first-cell address"
                >
                  Dirección
                </th>
                <th scope="col">
                  <div className="d-flex flex-column align-items-center">
                    <div
                      className={
                        'content-select mt-3 ' +
                        (data.filter((fav) =>
                          favs.find((id: number) => id.toString() === fav.id.toString()),
                        ).length > 3
                          ? 'active'
                          : '')
                      }
                    >
                      <select
                        disabled={
                          data.filter((fav) =>
                            favs.find((id: number) => id.toString() === fav.id.toString()),
                          ).length <= (screen.width > 992 ? 3 : 2)
                        }
                        name="updatePropI"
                        id="updatePropI"
                        ref={refTypeI}
                        defaultValue={null}
                        onChange={() => updatePropI()}
                      >
                        <option
                          selected={elI === null}
                          value="null"
                        >
                          Seleccionar propiedad
                        </option>
                        {data
                          ? data
                              .filter((fav) =>
                                favs.find((id: number) => id.toString() === fav.id.toString()),
                              )
                              .map((item, index) => (
                                <option
                                  checked={item?.id === elI?.id}
                                  value={item.id}
                                  disabled={elII?.id === item?.id || elIII?.id === item?.id}
                                  key={index}
                                >
                                  {getFakeAddres(item)} | {getLocation(item)} - {item.type.name}
                                </option>
                              ))
                          : ''}
                      </select>
                      <i></i>
                    </div>
                    {elI?.photos ? (
                      <>
                        <Slideshow
                          slides={getPreviewSlider(elI?.photos)}
                          name="slide-1"
                        />
                        <a
                          target={'_blank'}
                          href={makeLink(elI, global_data.divisionPath) + ''}
                          className={'link mb-3 ' + (elI ? '' : 'd-none')}
                        >
                          CONSULTAR
                        </a>
                      </>
                    ) : (
                      <>
                        <div className="skeleton-slider mt-3"></div>
                        <a className={'w-100 loader link mb-3 mx-auto d-block '}>CONSULTAR</a>
                      </>
                    )}
                  </div>
                </th>
                <th scope={'col'}>
                  <div className="d-flex flex-column align-items-center">
                    <div className={'content-select mt-3 ' + (elI?.id ? '' : 'loader')}>
                      <select
                        disabled={
                          !elI ||
                          data.filter((fav) =>
                            favs.find((id: number) => id.toString() === fav.id.toString()),
                          ).length <= (screen.width > 992 ? 3 : 2)
                        }
                        name="updatePropII"
                        id="updatePropII"
                        ref={refTypeII}
                        defaultValue={null}
                        onChange={() => updatePropII()}
                      >
                        <option
                          value="null"
                          selected
                        >
                          Seleccionar propiedad
                        </option>
                        {data
                          ? data
                              .filter((fav) =>
                                favs.find((id: number) => id.toString() === fav.id.toString()),
                              )
                              .map((item, index) => (
                                <option
                                  checked={item?.id === elI?.id}
                                  value={item.id}
                                  disabled={elI?.id === item?.id || elIII?.id === item?.id}
                                  key={index}
                                >
                                  {getFakeAddres(item)} | {getLocation(item)} - {item.type.name}
                                </option>
                              ))
                          : ''}
                      </select>
                      <i></i>
                    </div>
                    {elII?.photos ? (
                      <>
                        <Slideshow
                          slides={getPreviewSlider(elII?.photos)}
                          name="slide-2"
                        />
                        <a
                          target={'_blank'}
                          href={makeLink(elII, global_data.divisionPath) + ''}
                          className={'link mb-3 ' + (elII ? '' : 'd-none')}
                        >
                          CONSULTAR
                        </a>
                      </>
                    ) : (
                      <>
                        <div className="skeleton-slider mt-3"></div>
                        <a className={'w-100 loader link mb-3 mx-auto d-block '}>CONSULTAR</a>
                      </>
                    )}
                  </div>
                </th>
                <th
                  scope="col"
                  className={'d-none d-lg-table-cell'}
                >
                  <div className="d-flex flex-column align-items-center">
                    <div className={'content-select mt-3 ' + (elII?.id ? '' : 'loader')}>
                      <select
                        disabled={
                          !elII ||
                          data.filter((fav) =>
                            favs.find((id: number) => id.toString() === fav.id.toString()),
                          ).length <= (screen.width > 992 ? 3 : 2)
                        }
                        name="updatePropIII"
                        id="updatePropIII"
                        ref={refTypeIII}
                        defaultValue={null}
                        onChange={() => updatePropIII()}
                      >
                        <option value="null">Seleccionar propiedad</option>
                        {data
                          ? data
                              .filter((fav) =>
                                favs.find((id: number) => id.toString() === fav.id.toString()),
                              )
                              .map((item, index) => (
                                <option
                                  checked={item?.id === elI?.id}
                                  disabled={elII?.id === item?.id || elI?.id === item?.id}
                                  value={item.id}
                                  key={index}
                                >
                                  {getFakeAddres(item)} | {getLocation(item)} - {item.type.name}
                                </option>
                              ))
                          : ''}
                      </select>
                      <i></i>
                    </div>
                    {elIII?.photos ? (
                      <>
                        <Slideshow
                          slides={getPreviewSlider(elIII?.photos)}
                          name="slide-3"
                        />
                        <a
                          target={'_blank'}
                          href={makeLink(elIII, global_data.divisionPath) + ''}
                          className={'link mb-3 ' + (elIII ? '' : 'd-none')}
                        >
                          CONSULTAR
                        </a>
                      </>
                    ) : (
                      <>
                        <div className="skeleton-slider mt-3"></div>
                        <a className={'w-100 loader link mb-3 mx-auto d-block '}>CONSULTAR</a>
                      </>
                    )}
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              {FeaturedTr(elI, elII, elIII, points)}
              {OperationTypeTr(elI, elII, elIII)}
              {PriceTrVenta(elI, elII, elIII, comparated.priceVenta)}
              {PriceTrAlquiler(elI, elII, elIII, comparated.priceAlquiler)}
              {PriceTrAlquilerTemp(elI, elII, elIII, comparated.priceAlquilerTemp)}
              {Separator(elI, elII, elIII, 'Superficies')}
              {TotalSurfaceTr(elI, elII, elIII, comparated.total)}
              {RoofedSurfaceTr(elI, elII, elIII, comparated.roofed)}
              {SemiRoofedSurfaceTr(elI, elII, elIII, comparated.semiroofed)}
              {SurfaceTr(elI, elII, elIII, comparated.surface)}
              {Separator(elI, elII, elIII, 'Información básica')}
              {EnvironmentTr(elI, elII, elIII, comparated.environment)}
              {RoomsTr(elI, elII, elIII, comparated.room)}
              {ToiletsTr(elI, elII, elIII, comparated.toilets)}
              {BathroomsTr(elI, elII, elIII, comparated.bathrooms)}
              {AgeTr(elI, elII, elIII, comparated.age)}
              {/* {GarageTr(elI, elII, elIII, comparated.parking)} */}
              {Separator(elI, elII, elIII, 'Tipos de ambientes', type_environments)}
              {type_environments.map((environment) => TagTr(elI, elII, elIII, environment))}
              {Separator(elI, elII, elIII, 'Generales', generals)}
              {generals.map((general) => TagTr(elI, elII, elIII, general))}
              {/* {BarbacueTr(elI, elII, elIII)} */}
              {/* {PoolTr(elI, elII, elIII)} */}
              {Separator(elI, elII, elIII, 'Servicios', services)}
              {services.map((service) => TagTr(elI, elII, elIII, service))}
              {/* {BarbacueTr(elI, elII, elIII)} */}
              {/* {PoolTr(elI, elII, elIII)} */}
            </tbody>
          </table>
        </div>
      </div>
      {/* Data table con info para imprimir en el pdf - oculta en el html */}

      <div
        id="data-table-print"
        className="table-wrapper d-none"
      >
        <div className="table-responsive">
          <table className="table">
            {/* Thead */}
            <thead>
              <tr className="d-xs-table-row d-sm-none">
                <th
                  colSpan={2}
                  className="text-center first-cell py-3"
                >
                  Dirección
                </th>
              </tr>
              <tr>
                <th
                  scope="col"
                  className="d-none d-sm-table-cell first-cell address"
                >
                  Dirección
                </th>
                <th scope="col">
                  <div className="d-flex flex-column align-items-center">
                    <div className="content-select mt-3">
                      {getFakeAddres(elI)} | {getLocation(elI)}
                    </div>
                  </div>
                </th>
                <th scope="col">
                  <div className="d-flex flex-column align-items-center">
                    <div className="content-select mt-3">
                      {getFakeAddres(elII)} | {getLocation(elII)}
                    </div>
                  </div>
                </th>
                <th
                  scope="col"
                  className="d-none d-lg-table-cell"
                >
                  <div className="d-flex flex-column align-items-center">
                    <div className="content-select mt-3">
                      {getFakeAddres(elIII)} | {getLocation(elIII)}
                    </div>
                  </div>
                </th>
              </tr>
              <tr className="d-xs-table-row d-sm-none m-type-of-prop">
                <th
                  colSpan={2}
                  className="text-center first-cell py-3"
                >
                  Tipo de propiedad
                </th>
              </tr>
              <tr className="d-type-of-prop">
                <th
                  scope="col"
                  className="d-none d-sm-table-cell first-cell type"
                >
                  Tipo de propiedad
                </th>
                <th
                  scope="col"
                  className="type-text-headline"
                >
                  <div className="d-flex flex-column align-items-center">
                    <div className="content-select">{elI?.type?.name}</div>
                  </div>
                </th>
                <th
                  scope="col"
                  className="type-text-headline"
                >
                  <div className="d-flex flex-column align-items-center">
                    <div className="content-select">{elII?.type?.name}</div>
                  </div>
                </th>
                <th
                  scope="col"
                  className="d-none d-lg-table-cell type-text-headline"
                >
                  <div className="d-flex flex-column align-items-center">
                    <div className="content-select">{elIII?.type?.name}</div>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              {/* Featured */}
              {FeaturedTr(elI, elII, elIII, points)}
              {/* Operation type */}
              {OperationTypeTr(elI, elII, elIII)}
              {/* Venta */}
              {PriceTrVenta(elI, elII, elIII)}
              {/* Alquiler */}
              {PriceTrAlquiler(elI, elII, elIII, comparated.priceAlquiler)}
              {/* AlquilerTemp */}
              {PriceTrAlquilerTemp(elI, elII, elIII, comparated.priceAlquilerTemp)}
              {/* Expenses     */}
              {/* { ExpensesTr(elI, elII, elIII) } */}
              {/* Total surface */}
              {TotalSurfaceTr(elI, elII, elIII, comparated.total)}
              {/* Roofed surface */}
              {RoofedSurfaceTr(elI, elII, elIII)}
              {/* Semi roofed surface */}
              {SemiRoofedSurfaceTr(elI, elII, elIII)}
              {/* Surface */}
              {SurfaceTr(elI, elII, elIII)}
              {/* Environment */}
              {EnvironmentTr(elI, elII, elIII)}
              {/* Rooms */}
              {RoomsTr(elI, elII, elIII)}
              {/* Toilets */}
              {ToiletsTr(elI, elII, elIII, comparated.toilets)}
              {/* Bathrooms */}
              {BathroomsTr(elI, elII, elIII, comparated.bathrooms)}
              {/* Age */}
              {AgeTr(elI, elII, elIII)}
              {/* Garage */}
              {/* {GarageTr(elI, elII, elIII)} */}
              {/* Environment Type */}
              {type_environments.map((environment) => TagTr(elI, elII, elIII, environment))}
              {/* General */}
              {generals.map((general) => TagTr(elI, elII, elIII, general))}
              {/* Services */}
              {services.map((service) => TagTr(elI, elII, elIII, service))}
              {/* Barbacue */}
              {/* {BarbacueTr(elI, elII, elIII)} */}
              {/* Pool */}
              {/* {PoolTr(elI, elII, elIII)} */}
            </tbody>
          </table>
        </div>
      </div>
    </>
  )
}

const PDF = ({ elI, elII, elIII, points, comparated, global_data }) => {
  // Definimos los estilos

  const styles = StyleSheet.create({
    page: {
      flexDirection: 'column',
      padding: 10,
    },
    imageHeader: {
      width: '90%',
      height: '80px',
      objectFit: 'cover',
      margin: '5px 0px 10px 0px',
      borderRadius: '3px',
    },
    table: {
      display: 'table',
      width: 'auto',
      borderStyle: 'solid',
      borderWidth: 1,
      borderColor: '#bfbfbf',
      margin: '10px 0',
    },
    tableRow: {
      flexDirection: 'row',
    },
    tableCol: {
      width: '25%',
      borderStyle: 'solid',
      alignItems: 'center',
      flexDirection: 'column',
      justifyContent: 'center',
      position: 'relative',
      // borderWidth: 1,
      // borderColor: '#bfbfbf',
      borderBottom: '1px solid #bfbfbf',
      borderRight: '1px solid #bfbfbf',
    },
    tableColFlex: {
      width: '25%',
      borderStyle: 'solid',
      alignItems: 'center',
      flexDirection: 'row',
      justifyContent: 'center',
      // borderWidth: 1,
      // borderColor: '#bfbfbf',
      borderBottom: '1px solid #bfbfbf',
      borderRight: '1px solid #bfbfbf',
    },
    tableColSeparate: {
      width: '25%',
      borderStyle: 'solid',
      alignItems: 'center',
      display: 'flex',
      borderWidth: 1,
      borderColor: '#bfbfbf',
      backgroundColor: '#c4c4c4',
    },
    tableCell: {
      margin: 3,
      flexDirection: 'row',
      position: 'relative',
      fontSize: 6,
    },
    tableCellSeparate: {
      backgroundColor: '#c4c4c4',
      color: '#fff',
      margin: 3,
      fontSize: 6,
    },
    header: {
      backgroundColor: '#e0e0e0',
      fontWeight: 'bold',
    },
  })

  return (
    <Document>
      <Page
        size="A4"
        style={styles.page}
      >
        <View style={{ display: 'flex', flexDirection: 'column' }}>
          <Image
            style={{
              width: 'auto',
              maxWidth: '150px',
              height: 'auto',
              // height: '40px',
              objectFit: 'cover',
              display: 'flex',
              margin: '10px auto',
            }}
            src={global_data?.logo}
          ></Image>
        </View>
        <View style={styles.table}>
          {/* Cabecera de la tabla */}
          <View style={styles.tableRow}>
            <View style={styles.tableCol}>
              <Text style={styles.tableCell}>Descripción</Text>
            </View>
            <View style={styles.tableCol}>
              <Text style={styles.tableCell}>{getFakeAddres(elI) ?? 'Sin comparar'}</Text>
              <Image
                style={styles.imageHeader}
                src={elI?.photos ? getCover(elI?.photos).original : NoPicture}
              />
            </View>
            <View style={styles.tableCol}>
              <Text style={styles.tableCell}>{getFakeAddres(elII) ?? 'Sin comparar'}</Text>
              <Image
                style={styles.imageHeader}
                src={elI?.photos ? getCover(elII?.photos).original : NoPicture}
              />
            </View>
            <View style={styles.tableCol}>
              <Text style={styles.tableCell}>{getFakeAddres(elIII) ?? 'Sin comparar'}</Text>
              <Image
                style={styles.imageHeader}
                src={elI?.photos ? getCover(elIII?.photos).original : NoPicture}
              />
            </View>
          </View>
          <View style={styles.tableRow}>
            <View style={styles.tableCol}>
              <Text style={styles.tableCell}>{'Mejor opción'}</Text>
            </View>
            <View style={styles.tableColFlex}>
              <Image
                style={{
                  // marginBottom: '200px',
                  width: '10px',
                  height: '10px',
                  display: 'inline-block',
                }}
                src={FeaturedSVG}
              />
              <Text style={styles.tableCell}>{elI?.id ? points[0] : '-'}</Text>
            </View>
            <View style={styles.tableColFlex}>
              <Image
                style={{
                  width: '10px',
                  height: '10px',
                  display: 'block',
                }}
                src={FeaturedSVG}
              />
              <Text style={styles.tableCell}>{elII?.id ? points[1] : '-'}</Text>
            </View>
            <View style={styles.tableColFlex}>
              <Image
                style={{
                  width: '10px',
                  height: '10px',
                  display: 'block',
                }}
                src={FeaturedSVG}
              />
              <Text style={styles.tableCell}>{elIII?.id ? points[2] : '-'}</Text>
            </View>
          </View>
          {/* Fila 2 */}
          <View style={styles.tableRow}>
            <View style={styles.tableCol}>
              <Text style={styles.tableCell}>Operacion</Text>
            </View>
            <View style={styles.tableCol}>
              <Text style={styles.tableCell}>{elI?.id ? getOperations(elI).join(', ') : '-'}</Text>
            </View>
            <View style={styles.tableCol}>
              <Text style={styles.tableCell}>
                {elII?.id ? getOperations(elII).join(', ') : '-'}
              </Text>
            </View>
            <View style={styles.tableCol}>
              <Text style={styles.tableCell}>
                {elIII?.id ? getOperations(elIII).join(', ') : '-'}
              </Text>
            </View>
          </View>
          {/* Fila 3 Precio Venta*/}
          <View style={styles.tableRow}>
            <View style={styles.tableCol}>
              <Text style={styles.tableCell}>Valor Venta</Text>
            </View>
            <View style={styles.tableCol}>
              {elI?.id &&
                getPrices(elI).find((element) => element?.type === 'Venta')?.price ===
                  comparated.priceVenta && (
                  <Image
                    src={FeaturedSVG}
                    style={{
                      width: '10px',
                      height: '10px',
                      right: '5px',
                      top: 0,
                      position: 'absolute',
                    }}
                  ></Image>
                )}
              <Text style={styles.tableCell}>
                {elI?.id &&
                getPrices(elI).filter((element) => element?.type.toLowerCase() === 'venta').length >
                  0
                  ? getPrices(elI).find((element) => element?.type.toLowerCase() === 'venta')
                      .currency +
                    ' ' +
                    (parseInt(
                      getPrices(elI)
                        .find((element) => element?.type.toLowerCase() === 'venta')
                        .price?.toString()!,
                    )
                      ? Intl.NumberFormat('de-DE').format(
                          parseInt(
                            getPrices(elI)
                              .find((element) => element?.type.toLowerCase() === 'venta')
                              .price?.toString()!,
                          ),
                        )
                      : '-')
                  : '-'}
              </Text>
            </View>
            <View style={styles.tableCol}>
              {elII?.id &&
                getPrices(elII).find((element) => element?.type === 'Venta')?.price ===
                  comparated.priceVenta && (
                  <Image
                    src={FeaturedSVG}
                    style={{
                      width: '10px',
                      height: '10px',
                      right: '5px',
                      top: 0,
                      position: 'absolute',
                    }}
                  ></Image>
                )}
              <Text style={styles.tableCell}>
                {elII?.id &&
                getPrices(elII).filter((element) => element?.type.toLowerCase() === 'venta')
                  .length > 0
                  ? getPrices(elII).find((element) => element?.type.toLowerCase() === 'venta')
                      .currency +
                    ' ' +
                    (parseInt(
                      getPrices(elII)
                        .find((element) => element?.type.toLowerCase() === 'venta')
                        .price?.toString()!,
                    )
                      ? Intl.NumberFormat('de-DE').format(
                          parseInt(
                            getPrices(elII)
                              .find((element) => element?.type.toLowerCase() === 'venta')
                              .price?.toString()!,
                          ),
                        )
                      : '-')
                  : '-'}
              </Text>
            </View>
            <View style={styles.tableCol}>
              {elIII?.id &&
                getPrices(elIII).find((element) => element?.type === 'Venta')?.price ===
                  comparated.priceVenta && (
                  <Image
                    src={FeaturedSVG}
                    style={{
                      width: '10px',
                      height: '10px',
                      right: '5px',
                      top: 0,
                      position: 'absolute',
                    }}
                  ></Image>
                )}
              <Text style={styles.tableCell}>
                {elIII?.id &&
                getPrices(elIII).filter((element) => element?.type.toLowerCase() === 'venta')
                  .length > 0
                  ? getPrices(elIII).find((element) => element?.type.toLowerCase() === 'venta')
                      .currency +
                    ' ' +
                    (parseInt(
                      getPrices(elIII)
                        .find((element) => element?.type.toLowerCase() === 'venta')
                        .price?.toString()!,
                    )
                      ? Intl.NumberFormat('de-DE').format(
                          parseInt(
                            getPrices(elIII)
                              .find((element) => element?.type.toLowerCase() === 'venta')
                              .price?.toString()!,
                          ),
                        )
                      : '-')
                  : '-'}
              </Text>
            </View>
          </View>
          {/* Fila 4 Precio Alquiler */}
          <View style={styles.tableRow}>
            <View style={styles.tableCol}>
              <Text style={styles.tableCell}>Valor Alquiler</Text>
            </View>
            <View style={styles.tableCol}>
              {elI?.id &&
                getPrices(elI).find((element) => element?.type === 'Alquiler')?.price ===
                  comparated.priceAlquiler && (
                  <Image
                    src={FeaturedSVG}
                    style={{
                      width: '10px',
                      height: '10px',
                      right: '5px',
                      top: 0,
                      position: 'absolute',
                    }}
                  ></Image>
                )}
              <Text style={styles.tableCell}>
                {getPrices(elI).filter((element) => element?.type.toLowerCase() === 'alquiler')
                  .length > 0
                  ? getPrices(elI).find((element) => element?.type.toLowerCase() === 'alquiler')
                      .currency +
                    ' ' +
                    (parseInt(
                      getPrices(elI)
                        .find((element) => element?.type.toLowerCase() === 'alquiler')
                        .price?.toString()!,
                    )
                      ? Intl.NumberFormat('de-DE').format(
                          parseInt(
                            getPrices(elI)
                              .find((element) => element?.type.toLowerCase() === 'alquiler')
                              .price?.toString()!,
                          ),
                        )
                      : '-')
                  : '-'}
              </Text>
            </View>
            <View style={styles.tableCol}>
              {elII?.id &&
                getPrices(elII).find((element) => element?.type === 'Alquiler')?.price ===
                  comparated.priceAlquiler && (
                  <Image
                    src={FeaturedSVG}
                    style={{
                      width: '10px',
                      height: '10px',
                      right: '5px',
                      top: 0,
                      position: 'absolute',
                    }}
                  ></Image>
                )}
              <Text style={styles.tableCell}>
                {getPrices(elII).filter((element) => element?.type.toLowerCase() === 'alquiler')
                  .length > 0
                  ? getPrices(elII).find((element) => element?.type.toLowerCase() === 'alquiler')
                      .currency +
                    ' ' +
                    (parseInt(
                      getPrices(elII)
                        .find((element) => element?.type.toLowerCase() === 'alquiler')
                        .price?.toString()!,
                    )
                      ? Intl.NumberFormat('de-DE').format(
                          parseInt(
                            getPrices(elII)
                              .find((element) => element?.type.toLowerCase() === 'alquiler')
                              .price?.toString()!,
                          ),
                        )
                      : '-')
                  : '-'}
              </Text>
            </View>
            <View style={styles.tableCol}>
              {elIII?.id &&
                getPrices(elIII).find((element) => element?.type === 'Alquiler')?.price ===
                  comparated.priceAlquiler && (
                  <Image
                    src={FeaturedSVG}
                    style={{
                      width: '10px',
                      height: '10px',
                      right: '5px',
                      top: 0,
                      position: 'absolute',
                    }}
                  ></Image>
                )}
              <Text style={styles.tableCell}>
                {getPrices(elIII).filter((element) => element?.type.toLowerCase() === 'alquiler')
                  .length > 0
                  ? getPrices(elIII).find((element) => element?.type.toLowerCase() === 'alquiler')
                      .currency +
                    ' ' +
                    (parseInt(
                      getPrices(elIII)
                        .find((element) => element?.type.toLowerCase() === 'alquiler')
                        .price?.toString()!,
                    )
                      ? Intl.NumberFormat('de-DE').format(
                          parseInt(
                            getPrices(elIII)
                              .find((element) => element?.type.toLowerCase() === 'alquiler')
                              .price?.toString()!,
                          ),
                        )
                      : '-')
                  : '-'}
              </Text>
            </View>
          </View>
          {/* Fila 5 Precio Temporario*/}
          <View style={styles.tableRow}>
            <View style={styles.tableCol}>
              <Text style={styles.tableCell}>Valor Temporario</Text>
            </View>
            <View style={styles.tableCol}>
              {elI?.id &&
                getPrices(elI).find((element) => element?.type === 'Alquiler temporario')?.price ===
                  comparated.priceAlquilerTemp && (
                  <Image
                    src={FeaturedSVG}
                    style={{
                      width: '10px',
                      height: '10px',
                      right: '5px',
                      top: 0,
                      position: 'absolute',
                    }}
                  ></Image>
                )}
              <Text style={styles.tableCell}>
                {getPrices(elI).filter(
                  (element) => element?.type.toLowerCase() === 'alquiler temporario',
                ).length > 0
                  ? getPrices(elI).find(
                      (element) => element?.type.toLowerCase() === 'alquiler temporario',
                    ).currency +
                    ' ' +
                    (parseInt(
                      getPrices(elI)
                        .find((element) => element?.type.toLowerCase() === 'alquiler temporario')
                        .price?.toString()!,
                    )
                      ? Intl.NumberFormat('de-DE').format(
                          parseInt(
                            getPrices(elI)
                              .find(
                                (element) => element?.type.toLowerCase() === 'alquiler temporario',
                              )
                              .price?.toString()!,
                          ),
                        )
                      : '-')
                  : '-'}
              </Text>
            </View>
            <View style={styles.tableCol}>
              {elII?.id &&
                getPrices(elII).find((element) => element?.type === 'Alquiler temporario')
                  ?.price === comparated.priceAlquilerTemp && (
                  <Image
                    src={FeaturedSVG}
                    style={{
                      width: '10px',
                      height: '10px',
                      right: '5px',
                      top: 0,
                      position: 'absolute',
                    }}
                  ></Image>
                )}
              <Text style={styles.tableCell}>
                {getPrices(elII).filter(
                  (element) => element?.type.toLowerCase() === 'alquiler temporario',
                ).length > 0
                  ? getPrices(elII).find(
                      (element) => element?.type.toLowerCase() === 'alquiler temporario',
                    ).currency +
                    ' ' +
                    (parseInt(
                      getPrices(elII)
                        .find((element) => element?.type.toLowerCase() === 'alquiler temporario')
                        .price?.toString()!,
                    )
                      ? Intl.NumberFormat('de-DE').format(
                          parseInt(
                            getPrices(elII)
                              .find(
                                (element) => element?.type.toLowerCase() === 'alquiler temporario',
                              )
                              .price?.toString()!,
                          ),
                        )
                      : '-')
                  : '-'}
              </Text>
            </View>
            <View style={styles.tableCol}>
              {elIII?.id &&
                getPrices(elIII).find((element) => element?.type === 'Alquiler temporario')
                  ?.price === comparated.priceAlquilerTemp && (
                  <Image
                    src={FeaturedSVG}
                    style={{
                      width: '10px',
                      height: '10px',
                      right: '5px',
                      top: 0,
                      position: 'absolute',
                    }}
                  ></Image>
                )}
              <Text style={styles.tableCell}>
                {getPrices(elIII).filter(
                  (element) => element?.type.toLowerCase() === 'alquiler temporario',
                ).length > 0
                  ? getPrices(elIII).find(
                      (element) => element?.type.toLowerCase() === 'alquiler temporario',
                    ).currency +
                    ' ' +
                    (parseInt(
                      getPrices(elIII)
                        .find((element) => element?.type.toLowerCase() === 'alquiler temporario')
                        .price?.toString()!,
                    )
                      ? Intl.NumberFormat('de-DE').format(
                          parseInt(
                            getPrices(elIII)
                              .find(
                                (element) => element?.type.toLowerCase() === 'alquiler temporario',
                              )
                              .price?.toString()!,
                          ),
                        )
                      : '-')
                  : '-'}
              </Text>
            </View>
          </View>
          {/* Fila 6 Superficies */}
          <View style={styles.tableRow}>
            <View style={styles.tableColSeparate}>
              <Text style={styles.tableCellSeparate}>Superficies</Text>
            </View>
            <View style={styles.tableColSeparate}>
              <Text style={styles.tableCellSeparate}></Text>
            </View>
            <View style={styles.tableColSeparate}>
              <Text style={styles.tableCellSeparate}></Text>
            </View>
            <View style={styles.tableColSeparate}>
              <Text style={styles.tableCellSeparate}></Text>
            </View>
          </View>
          {/* Fila 7 Sup.Total*/}
          <View style={styles.tableRow}>
            <View style={styles.tableCol}>
              <Text style={styles.tableCell}>Sup.total</Text>
            </View>
            <View style={styles.tableCol}>
              {elI?.id &&
                parseInt(elI?.total_surface) === comparated.total &&
                (parseInt(elI?.total_surface) !== parseInt(elII?.total_surface) ||
                  parseInt(elI?.total_surface) !== parseInt(elIII?.total_surface)) && (
                  <Image
                    src={FeaturedSVG}
                    style={{
                      width: '10px',
                      height: '10px',
                      right: '5px',
                      top: 0,
                      position: 'absolute',
                    }}
                  ></Image>
                )}
              <Text style={styles.tableCell}>
                {elI?.id
                  ? parseInt(elI?.total_surface) === 0
                    ? 'No especificado'
                    : parseInt(elI?.total_surface) + ' m2' || 'No especificado'
                  : ''}
              </Text>
            </View>
            <View style={styles.tableCol}>
              {elII?.id &&
                parseInt(elII?.total_surface) === comparated.total &&
                (parseInt(elII?.total_surface) !== parseInt(elI?.total_surface) ||
                  parseInt(elII?.total_surface) !== parseInt(elIII?.total_surface)) && (
                  <Image
                    src={FeaturedSVG}
                    style={{
                      width: '10px',
                      height: '10px',
                      right: '5px',
                      top: 0,
                      position: 'absolute',
                    }}
                  ></Image>
                )}
              <Text style={styles.tableCell}>
                {elII?.id
                  ? parseInt(elII?.total_surface) === 0
                    ? 'No especificado'
                    : parseInt(elII?.total_surface) + ' m2' || 'No especificado'
                  : ''}
              </Text>
            </View>
            <View style={styles.tableCol}>
              {elIII?.id &&
                parseInt(elIII?.total_surface) === comparated.total &&
                (parseInt(elIII?.total_surface) !== parseInt(elII?.total_surface) ||
                  parseInt(elI?.total_surface) !== parseInt(elIII?.total_surface)) && (
                  <Image
                    src={FeaturedSVG}
                    style={{
                      width: '10px',
                      height: '10px',
                      right: '5px',
                      top: 0,
                      position: 'absolute',
                    }}
                  ></Image>
                )}
              <Text style={styles.tableCell}>
                {elIII?.id
                  ? parseInt(elIII?.total_surface) === 0
                    ? 'No especificado'
                    : parseInt(elIII?.total_surface) + ' m2' || 'No especificado'
                  : ''}
              </Text>
            </View>
          </View>
          {/* Fila 8 Sup.Cubierta*/}
          <View style={styles.tableRow}>
            <View style={styles.tableCol}>
              <Text style={styles.tableCell}>Sup.cubierta</Text>
            </View>
            <View style={styles.tableCol}>
              {elI?.id &&
                parseInt(elI?.roofed_surface) === comparated.roofed &&
                (parseInt(elI?.roofed_surface) !== parseInt(elII?.roofed_surface) ||
                  parseInt(elI?.roofed_surface) !== parseInt(elIII?.roofed_surface)) && (
                  <Image
                    src={FeaturedSVG}
                    style={{
                      width: '10px',
                      height: '10px',
                      right: '5px',
                      top: 0,
                      position: 'absolute',
                    }}
                  ></Image>
                )}
              <Text style={styles.tableCell}>
                {elI?.id
                  ? parseInt(elI?.roofed_surface) === 0
                    ? 'No especificado'
                    : parseInt(elI?.roofed_surface) + ' m2' || 'No especificado'
                  : ''}
              </Text>
            </View>
            <View style={styles.tableCol}>
              {elII?.id &&
                parseInt(elII?.roofed_surface) === comparated.roofed &&
                (parseInt(elIII?.roofed_surface) !== parseInt(elII?.roofed_surface) ||
                  parseInt(elII?.roofed_surface) !== parseInt(elI?.roofed_surface)) && (
                  <Image
                    src={FeaturedSVG}
                    style={{
                      width: '10px',
                      height: '10px',
                      right: '5px',
                      top: 0,
                      position: 'absolute',
                    }}
                  ></Image>
                )}
              <Text style={styles.tableCell}>
                {elII?.id
                  ? parseInt(elII?.roofed_surface) === 0
                    ? 'No especificado'
                    : parseInt(elII?.roofed_surface) + ' m2' || 'No especificado'
                  : ''}
              </Text>
            </View>
            <View style={styles.tableCol}>
              {elIII?.id &&
                parseInt(elIII?.roofed_surface) === comparated.roofed &&
                (parseInt(elI?.roofed_surface) !== parseInt(elIII?.roofed_surface) ||
                  parseInt(elII?.roofed_surface) !== parseInt(elIII?.roofed_surface)) && (
                  <Image
                    src={FeaturedSVG}
                    style={{
                      width: '10px',
                      height: '10px',
                      right: '5px',
                      top: 0,
                      position: 'absolute',
                    }}
                  ></Image>
                )}
              <Text style={styles.tableCell}>
                {elIII?.id
                  ? parseInt(elIII?.roofed_surface) === 0
                    ? 'No especificado'
                    : parseInt(elIII?.roofed_surface) + ' m2' || 'No especificado'
                  : ''}
              </Text>
            </View>
          </View>
          {/* Fila 9 Sup.SemiCubierta*/}
          <View style={styles.tableRow}>
            <View style={styles.tableCol}>
              <Text style={styles.tableCell}>Sup. semicubierta</Text>
            </View>
            <View style={styles.tableCol}>
              {elI?.id &&
                parseInt(elI?.semiroofed_surface) === comparated.semiroofed &&
                (parseInt(elI?.semiroofed_surface) !== parseInt(elII?.semiroofed_surface) ||
                  parseInt(elI?.semiroofed_surface) !== parseInt(elIII?.semiroofed_surface)) && (
                  <Image
                    src={FeaturedSVG}
                    style={{
                      width: '10px',
                      height: '10px',
                      right: '5px',
                      top: 0,
                      position: 'absolute',
                    }}
                  ></Image>
                )}
              <Text style={styles.tableCell}>
                {elI?.id
                  ? parseInt(elI?.semiroofed_surface) === 0
                    ? 'No especificado'
                    : parseInt(elI?.semiroofed_surface) + ' m2' || 'No especificado'
                  : ''}
              </Text>
            </View>
            <View style={styles.tableCol}>
              {elII?.id &&
                parseInt(elII?.semiroofed_surface) === comparated.semiroofed &&
                (parseInt(elIII?.semiroofed_surface) !== parseInt(elI?.semiroofed_surface) ||
                  parseInt(elII?.semiroofed_surface) !== parseInt(elIII?.semiroofed_surface)) && (
                  <Image
                    src={FeaturedSVG}
                    style={{
                      width: '10px',
                      height: '10px',
                      right: '5px',
                      top: 0,
                      position: 'absolute',
                    }}
                  ></Image>
                )}
              <Text style={styles.tableCell}>
                {elII?.id
                  ? parseInt(elII?.semiroofed_surface) === 0
                    ? 'No especificado'
                    : parseInt(elII?.semiroofed_surface) + ' m2' || 'No especificado'
                  : ''}
              </Text>
            </View>
            <View style={styles.tableCol}>
              {elIII?.id &&
                parseInt(elIII?.semiroofed_surface) === comparated.semiroofed &&
                (parseInt(elIII?.semiroofed_surface) !== parseInt(elII?.semiroofed_surface) ||
                  parseInt(elI?.semiroofed_surface) !== parseInt(elIII?.semiroofed_surface)) && (
                  <Image
                    src={FeaturedSVG}
                    style={{
                      width: '10px',
                      height: '10px',
                      right: '5px',
                      top: 0,
                      position: 'absolute',
                    }}
                  ></Image>
                )}
              <Text style={styles.tableCell}>
                {elIII?.id
                  ? parseInt(elIII?.semiroofed_surface) === 0
                    ? 'No especificado'
                    : parseInt(elIII?.semiroofed_surface) + ' m2' || 'No especificado'
                  : ''}
              </Text>
            </View>
          </View>
          {/* Fila 10 Sup.Terreno */}
          <View style={styles.tableRow}>
            <View style={styles.tableCol}>
              <Text style={styles.tableCell}>Sup. terreno</Text>
            </View>
            <View style={styles.tableCol}>
              {elI?.id &&
                parseInt(elI?.surface) === comparated.surface &&
                (parseInt(elI?.surface) !== parseInt(elII?.surface) ||
                  parseInt(elI?.surface) !== parseInt(elIII?.surface)) && (
                  <Image
                    src={FeaturedSVG}
                    style={{
                      width: '10px',
                      height: '10px',
                      right: '5px',
                      top: 0,
                      position: 'absolute',
                    }}
                  ></Image>
                )}
              <Text style={styles.tableCell}>
                {elI?.id
                  ? parseInt(elI?.surface) === 0
                    ? 'No especificado'
                    : parseInt(elI?.surface) + ' m2' || 'No especificado'
                  : ''}
              </Text>
            </View>
            <View style={styles.tableCol}>
              {elII?.id &&
                parseInt(elII?.surface) === comparated.surface &&
                (parseInt(elII?.surface) !== parseInt(elI?.surface) ||
                  parseInt(elII?.surface) !== parseInt(elIII?.surface)) && (
                  <Image
                    src={FeaturedSVG}
                    style={{
                      width: '10px',
                      height: '10px',
                      right: '5px',
                      top: 0,
                      position: 'absolute',
                    }}
                  ></Image>
                )}
              <Text style={styles.tableCell}>
                {elII?.id
                  ? parseInt(elII?.surface) === 0
                    ? 'No especificado'
                    : parseInt(elII?.surface) + ' m2' || 'No especificado'
                  : ''}
              </Text>
            </View>
            <View style={styles.tableCol}>
              {elIII?.id &&
                parseInt(elIII?.surface) === comparated.surface &&
                (parseInt(elIII?.surface) !== parseInt(elII?.surface) ||
                  parseInt(elI?.surface) !== parseInt(elIII?.surface)) && (
                  <Image
                    src={FeaturedSVG}
                    style={{
                      width: '10px',
                      height: '10px',
                      right: '5px',
                      top: 0,
                      position: 'absolute',
                    }}
                  ></Image>
                )}
              <Text style={styles.tableCell}>
                {elIII?.id
                  ? parseInt(elIII?.surface) === 0
                    ? 'No especificado'
                    : parseInt(elIII?.surface) + ' m2' || 'No especificado'
                  : ''}
              </Text>
            </View>
          </View>
          {/* Fila 11 */}
          <View style={styles.tableRow}>
            <View style={styles.tableColSeparate}>
              <Text style={styles.tableCellSeparate}>Información básica </Text>
            </View>
            <View style={styles.tableColSeparate}></View>
            <View style={styles.tableColSeparate}></View>
            <View style={styles.tableColSeparate}></View>
          </View>
          {/* Fila 12 Ambientes */}
          <View style={styles.tableRow}>
            <View style={styles.tableCol}>
              <Text style={styles.tableCell}>Ambientes</Text>
            </View>
            <View style={styles.tableCol}>
              {elI?.id &&
                getEnvironment(elI) === comparated.environment &&
                (getEnvironment(elI) !== getEnvironment(elII) ||
                  getEnvironment(elI) !== getEnvironment(elIII)) && (
                  <Image
                    src={FeaturedSVG}
                    style={{
                      width: '10px',
                      height: '10px',
                      right: '5px',
                      top: 0,
                      position: 'absolute',
                    }}
                  ></Image>
                )}
              <Text style={styles.tableCell}>{elI?.id ? getEnvironment(elI) : ''}</Text>
            </View>
            <View style={styles.tableCol}>
              {elII?.id &&
                getEnvironment(elII) === comparated.environment &&
                (getEnvironment(elII) !== getEnvironment(elIII) ||
                  getEnvironment(elII) !== getEnvironment(elIII)) && (
                  <Image
                    src={FeaturedSVG}
                    style={{
                      width: '10px',
                      height: '10px',
                      right: '5px',
                      top: 0,
                      position: 'absolute',
                    }}
                  ></Image>
                )}
              <Text style={styles.tableCell}>{elII?.id ? getEnvironment(elII) : ''}</Text>
            </View>
            <View style={styles.tableCol}>
              {elIII?.id &&
                getEnvironment(elIII) === comparated.environment &&
                (getEnvironment(elIII) !== getEnvironment(elI) ||
                  getEnvironment(elIII) !== getEnvironment(elII)) && (
                  <Image
                    src={FeaturedSVG}
                    style={{
                      width: '10px',
                      height: '10px',
                      right: '5px',
                      top: 0,
                      position: 'absolute',
                    }}
                  ></Image>
                )}
              <Text style={styles.tableCell}>{elIII?.id ? getEnvironment(elIII) : ''}</Text>
            </View>
          </View>
          {/* Fila 12 Dormitorios */}
          <View style={styles.tableRow}>
            <View style={styles.tableCol}>
              <Text style={styles.tableCell}>Dormitorios</Text>
            </View>
            <View style={styles.tableCol}>
              {elI?.id &&
                getRooms(elI) === comparated.room &&
                (getRooms(elI) !== getRooms(elII) || getRooms(elI) !== getRooms(elIII)) && (
                  <Image
                    src={FeaturedSVG}
                    style={{
                      width: '10px',
                      height: '10px',
                      right: '5px',
                      top: 0,
                      position: 'absolute',
                    }}
                  ></Image>
                )}
              <Text style={styles.tableCell}>{elI?.id ? getRooms(elI) : ''}</Text>
            </View>
            <View style={styles.tableCol}>
              {elII?.id &&
                getRooms(elII) === comparated.room &&
                (getRooms(elII) !== getRooms(elI) || getRooms(elII) !== getRooms(elIII)) && (
                  <Image
                    src={FeaturedSVG}
                    style={{
                      width: '10px',
                      height: '10px',
                      right: '5px',
                      top: 0,
                      position: 'absolute',
                    }}
                  ></Image>
                )}
              <Text style={styles.tableCell}>{elII?.id ? getRooms(elII) : ''}</Text>
            </View>
            <View style={styles.tableCol}>
              {elIII?.id &&
                getRooms(elIII) === comparated.room &&
                (getRooms(elIII) !== getRooms(elII) || getRooms(elIII) !== getRooms(elI)) && (
                  <Image
                    src={FeaturedSVG}
                    style={{
                      width: '10px',
                      height: '10px',
                      right: '5px',
                      top: 0,
                      position: 'absolute',
                    }}
                  ></Image>
                )}
              <Text style={styles.tableCell}>{elIII?.id ? getRooms(elIII) : ''}</Text>
            </View>
          </View>
          {/* Fila 13 Toilettes */}
          <View style={styles.tableRow}>
            <View style={styles.tableCol}>
              <Text style={styles.tableCell}>Toilettes</Text>
            </View>
            <View style={styles.tableCol}>
              {elI?.id &&
                getToilets(elI) === comparated.toilets &&
                (getToilets(elI) !== getToilets(elII) || getToilets(elI) !== getToilets(elIII)) && (
                  <Image
                    src={FeaturedSVG}
                    style={{
                      width: '10px',
                      height: '10px',
                      right: '5px',
                      top: 0,
                      position: 'absolute',
                    }}
                  ></Image>
                )}
              <Text style={styles.tableCell}>{elI?.id ? getToilets(elI) : ''}</Text>
            </View>
            <View style={styles.tableCol}>
              {elII?.id &&
                getToilets(elII) === comparated.toilets &&
                (getToilets(elII) !== getToilets(elI) ||
                  getToilets(elII) !== getToilets(elIII)) && (
                  <Image
                    src={FeaturedSVG}
                    style={{
                      width: '10px',
                      height: '10px',
                      right: '5px',
                      top: 0,
                      position: 'absolute',
                    }}
                  ></Image>
                )}
              <Text style={styles.tableCell}>{elII?.id ? getToilets(elII) : ''}</Text>
            </View>
            <View style={styles.tableCol}>
              {elIII?.id &&
                getToilets(elIII) === comparated.toilets &&
                (getToilets(elIII) !== getToilets(elII) ||
                  getToilets(elIII) !== getToilets(elI)) && (
                  <Image
                    src={FeaturedSVG}
                    style={{
                      width: '10px',
                      height: '10px',
                      right: '5px',
                      top: 0,
                      position: 'absolute',
                    }}
                  ></Image>
                )}
              <Text style={styles.tableCell}>{elIII?.id ? getToilets(elIII) : ''}</Text>
            </View>
          </View>
          {/* Fila 14 Baños */}
          <View style={styles.tableRow}>
            <View style={styles.tableCol}>
              <Text style={styles.tableCell}>Baños</Text>
            </View>
            <View style={styles.tableCol}>
              {elI?.id &&
                getBathrooms(elI) === comparated.bathrooms &&
                (getBathrooms(elI) !== getBathrooms(elII) ||
                  getBathrooms(elI) !== getBathrooms(elIII)) && (
                  <Image
                    src={FeaturedSVG}
                    style={{
                      width: '10px',
                      height: '10px',
                      right: '5px',
                      top: 0,
                      position: 'absolute',
                    }}
                  ></Image>
                )}
              <Text style={styles.tableCell}>{elI?.id ? getBathrooms(elI) : ''}</Text>
            </View>
            <View style={styles.tableCol}>
              {elII?.id &&
                getBathrooms(elII) === comparated.bathrooms &&
                (getBathrooms(elII) !== getBathrooms(elI) ||
                  getBathrooms(elII) !== getBathrooms(elIII)) && (
                  <Image
                    src={FeaturedSVG}
                    style={{
                      width: '10px',
                      height: '10px',
                      right: '5px',
                      top: 0,
                      position: 'absolute',
                    }}
                  ></Image>
                )}
              <Text style={styles.tableCell}>{elII?.id ? getBathrooms(elII) : ''}</Text>
            </View>
            <View style={styles.tableCol}>
              {elIII?.id &&
                getBathrooms(elIII) === comparated.bathrooms &&
                (getBathrooms(elIII) !== getBathrooms(elII) ||
                  getBathrooms(elI) !== getBathrooms(elIII)) && (
                  <Image
                    src={FeaturedSVG}
                    style={{
                      width: '10px',
                      height: '10px',
                      right: '5px',
                      top: 0,
                      position: 'absolute',
                    }}
                  ></Image>
                )}
              <Text style={styles.tableCell}>{elIII?.id ? getBathrooms(elIII) : ''}</Text>
            </View>
          </View>
          {/* Fila 15 Antiguedad */}
          <View style={styles.tableRow}>
            <View style={styles.tableCol}>
              <Text style={styles.tableCell}>Antiguedad</Text>
            </View>
            <View style={styles.tableCol}>
              {elI?.id &&
                elI?.age === comparated.age &&
                (elI?.age !== elII?.age || elI?.age !== elIII?.age) && (
                  <Image
                    src={FeaturedSVG}
                    style={{
                      width: '10px',
                      height: '10px',
                      right: '5px',
                      top: 0,
                      position: 'absolute',
                    }}
                  ></Image>
                )}
              <Text style={styles.tableCell}>{elI?.id ? getAge(elI) : ''}</Text>
            </View>
            <View style={styles.tableCol}>
              {elII?.id &&
                elII?.age === comparated.age &&
                (elII?.age !== elIII?.age || elII?.age !== elI?.age) && (
                  <Image
                    src={FeaturedSVG}
                    style={{
                      width: '10px',
                      height: '10px',
                      right: '5px',
                      top: 0,
                      position: 'absolute',
                    }}
                  ></Image>
                )}
              <Text style={styles.tableCell}>{elII?.id ? getAge(elII) : ''}</Text>
            </View>
            <View style={styles.tableCol}>
              {elIII?.id &&
                elIII?.age === comparated.age &&
                (elIII?.age !== elI?.age || elIII?.age !== elII?.age) && (
                  <Image
                    src={FeaturedSVG}
                    style={{
                      width: '10px',
                      height: '10px',
                      right: '5px',
                      top: 0,
                      position: 'absolute',
                    }}
                  ></Image>
                )}
              <Text style={styles.tableCell}>{elIII?.id ? getAge(elIII) : ''}</Text>
            </View>
          </View>
          {/* Fila 17 Tipo ambientes */}
          {type_environments.filter(
            (t_env) => hasTag(elI, t_env.id) || hasTag(elII, t_env.id) || hasTag(elIII, t_env.id),
          ).length !== 0 && (
            <View style={styles.tableRow}>
              <View style={styles.tableColSeparate}>
                <Text style={styles.tableCellSeparate}>Tipos de ambientes </Text>
              </View>
              <View style={styles.tableColSeparate}></View>
              <View style={styles.tableColSeparate}></View>
              <View style={styles.tableColSeparate}></View>
            </View>
          )}
          {type_environments.map(
            (t_env, index) =>
              (hasTag(elI, t_env.id) || hasTag(elII, t_env.id) || hasTag(elIII, t_env.id)) && (
                <View style={styles.tableRow}>
                  <View style={styles.tableCol}>
                    <Text style={styles.tableCell}>{t_env.name}</Text>
                  </View>
                  <View style={styles.tableCol}>
                    {elI?.id &&
                      (hasTag(elI, t_env?.id) &&
                      (!hasTag(elII, t_env?.id) || !hasTag(elIII, t_env?.id)) ? (
                        <Image
                          src={FeaturedSVG}
                          style={{
                            width: '10px',
                            height: '10px',
                            right: '5px',
                            top: 0,
                            position: 'absolute',
                          }}
                        ></Image>
                      ) : (
                        ''
                      ))}
                    <Text style={styles.tableCell}>
                      {elI?.id ? (
                        <Image
                          style={{ width: '20px', height: '8px' }}
                          src={hasTag(elI, t_env?.id) ? CheckPNG : NonePNG}
                        ></Image>
                      ) : (
                        ''
                      )}
                    </Text>
                  </View>
                  <View style={styles.tableCol}>
                    {elII?.id &&
                      (hasTag(elII, t_env?.id) &&
                      (!hasTag(elI, t_env?.id) || !hasTag(elIII, t_env?.id)) ? (
                        <Image
                          src={FeaturedSVG}
                          style={{
                            width: '10px',
                            height: '10px',
                            right: '5px',
                            top: 0,
                            position: 'absolute',
                          }}
                        ></Image>
                      ) : (
                        ''
                      ))}
                    <Text style={styles.tableCell}>
                      {elII?.id ? (
                        <Image
                          style={{ width: '10px', height: '8px' }}
                          src={hasTag(elII, t_env?.id) ? CheckPNG : NonePNG}
                        ></Image>
                      ) : (
                        ''
                      )}
                    </Text>
                  </View>
                  <View style={styles.tableCol}>
                    {elIII?.id &&
                      (hasTag(elIII, t_env?.id) &&
                      (!hasTag(elI, t_env?.id) || !hasTag(elII, t_env?.id)) ? (
                        <Image
                          src={FeaturedSVG}
                          style={{
                            width: '10px',
                            height: '10px',
                            right: '5px',
                            top: 0,
                            position: 'absolute',
                          }}
                        ></Image>
                      ) : (
                        ''
                      ))}
                    <Text style={styles.tableCell}>
                      {elIII?.id ? (
                        <Image
                          style={{ width: '10px', height: '8px' }}
                          src={hasTag(elIII, t_env?.id) ? CheckPNG : NonePNG}
                        ></Image>
                      ) : (
                        ''
                      )}
                    </Text>
                  </View>
                </View>
              ),
          )}
          {/* Fila 18 Generales */}
          {generals.filter(
            (general) =>
              hasTag(elI, general.id) || hasTag(elII, general.id) || hasTag(elIII, general.id),
          ).length !== 0 && (
            <View style={styles.tableRow}>
              <View style={styles.tableColSeparate}>
                <Text style={styles.tableCellSeparate}>Generales </Text>
              </View>
              <View style={styles.tableColSeparate}></View>
              <View style={styles.tableColSeparate}></View>
              <View style={styles.tableColSeparate}></View>
            </View>
          )}
          {generals.map(
            (general, index) =>
              (hasTag(elI, general.id) ||
                hasTag(elII, general.id) ||
                hasTag(elIII, general.id)) && (
                <View style={styles.tableRow}>
                  <View style={styles.tableCol}>
                    <Text style={styles.tableCell}>{general.name}</Text>
                  </View>
                  <View style={styles.tableCol}>
                    {elI?.id &&
                      (hasTag(elI, general?.id) &&
                      (!hasTag(elII, general?.id) || !hasTag(elIII, general?.id)) ? (
                        <Image
                          src={FeaturedSVG}
                          style={{
                            width: '10px',
                            height: '10px',
                            right: '5px',
                            top: 0,
                            position: 'absolute',
                          }}
                        ></Image>
                      ) : (
                        ''
                      ))}
                    <Text style={styles.tableCell}>
                      {elI?.id ? (
                        <Image
                          style={{ width: '20px', height: '8px' }}
                          src={hasTag(elI, general?.id) ? CheckPNG : NonePNG}
                        ></Image>
                      ) : (
                        ''
                      )}
                    </Text>
                  </View>
                  <View style={styles.tableCol}>
                    {elII?.id &&
                      (hasTag(elII, general?.id) &&
                      (!hasTag(elI, general?.id) || !hasTag(elIII, general?.id)) ? (
                        <Image
                          src={FeaturedSVG}
                          style={{
                            width: '10px',
                            height: '10px',
                            right: '5px',
                            top: 0,
                            position: 'absolute',
                          }}
                        ></Image>
                      ) : (
                        ''
                      ))}
                    <Text style={styles.tableCell}>
                      {elII?.id ? (
                        <Image
                          style={{ width: '10px', height: '8px' }}
                          src={hasTag(elII, general?.id) ? CheckPNG : NonePNG}
                        ></Image>
                      ) : (
                        ''
                      )}
                    </Text>
                  </View>
                  <View style={styles.tableCol}>
                    {elIII?.id &&
                      (hasTag(elIII, general?.id) &&
                      (!hasTag(elI, general?.id) || !hasTag(elII, general?.id)) ? (
                        <Image
                          src={FeaturedSVG}
                          style={{
                            width: '10px',
                            height: '10px',
                            right: '5px',
                            top: 0,
                            position: 'absolute',
                          }}
                        ></Image>
                      ) : (
                        ''
                      ))}
                    <Text style={styles.tableCell}>
                      {elIII?.id ? (
                        <Image
                          style={{ width: '10px', height: '8px' }}
                          src={hasTag(elIII, general?.id) ? CheckPNG : NonePNG}
                        ></Image>
                      ) : (
                        ''
                      )}
                    </Text>
                  </View>
                </View>
              ),
          )}
          {/* Fila 19 Servicios */}
          {services.filter(
            (service) =>
              hasTag(elI, service.id) || hasTag(elII, service.id) || hasTag(elIII, service.id),
          ).length !== 0 && (
            <View style={styles.tableRow}>
              <View style={styles.tableColSeparate}>
                <Text style={styles.tableCellSeparate}>Servicios </Text>
              </View>
              <View style={styles.tableColSeparate}></View>
              <View style={styles.tableColSeparate}></View>
              <View style={styles.tableColSeparate}></View>
            </View>
          )}
          {services.map(
            (service, index) =>
              (hasTag(elI, service.id) ||
                hasTag(elII, service.id) ||
                hasTag(elIII, service.id)) && (
                <View style={styles.tableRow}>
                  <View style={styles.tableCol}>
                    <Text style={styles.tableCell}>{service.name}</Text>
                  </View>
                  <View style={styles.tableCol}>
                    {elI?.id &&
                      (hasTag(elI, service?.id) &&
                      (!hasTag(elIII, service?.id) || !hasTag(elII, service?.id)) ? (
                        <Image
                          src={FeaturedSVG}
                          style={{
                            width: '10px',
                            height: '10px',
                            right: '5px',
                            top: 0,
                            position: 'absolute',
                          }}
                        ></Image>
                      ) : (
                        ''
                      ))}
                    <Text style={styles.tableCell}>
                      {elI?.id ? (
                        <Image
                          style={{ width: '20px', height: '8px' }}
                          src={hasTag(elI, service?.id) ? CheckPNG : NonePNG}
                        ></Image>
                      ) : (
                        ''
                      )}
                    </Text>
                  </View>
                  <View style={styles.tableCol}>
                    {elII?.id &&
                      (hasTag(elII, service?.id) &&
                      (!hasTag(elIII, service?.id) || !hasTag(elI, service?.id)) ? (
                        <Image
                          src={FeaturedSVG}
                          style={{
                            width: '10px',
                            height: '10px',
                            right: '5px',
                            top: 0,
                            position: 'absolute',
                          }}
                        ></Image>
                      ) : (
                        ''
                      ))}
                    <Text style={styles.tableCell}>
                      {elII?.id ? (
                        <Image
                          style={{ width: '10px', height: '8px' }}
                          src={hasTag(elII, service?.id) ? CheckPNG : NonePNG}
                        ></Image>
                      ) : (
                        ''
                      )}
                    </Text>
                  </View>
                  <View style={styles.tableCol}>
                    {elIII?.id &&
                      (hasTag(elIII, service?.id) &&
                      (!hasTag(elII, service?.id) || !hasTag(elI, service?.id)) ? (
                        <Image
                          src={FeaturedSVG}
                          style={{
                            width: '10px',
                            height: '10px',
                            right: '5px',
                            top: 0,
                            position: 'absolute',
                          }}
                        ></Image>
                      ) : (
                        ''
                      ))}
                    <Text style={styles.tableCell}>
                      {elIII?.id ? (
                        <Image
                          style={{ width: '10px', height: '8px' }}
                          src={hasTag(elIII, service?.id) ? CheckPNG : NonePNG}
                        ></Image>
                      ) : (
                        ''
                      )}
                    </Text>
                  </View>
                </View>
              ),
          )}
          {/* Puedes agregar más filas aquí */}
        </View>
        <View
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            marginTop: '10px',
            justifyContent: 'center',
          }}
        >
          <Text style={{ fontSize: 7 }}>
            {global_data?.branches[0]?.address} {global_data?.branches[0]?.city}{' '}
            {global_data?.branches[0]?.country}{' '}
            {global_data?.contact_data?.phoneMobile[0]
              ? '- Cel: ' + global_data?.contact_data.phoneMobile[0]
              : ''}{' '}
            {global_data?.contact_data?.phoneLine[0]
              ? '- Tel: ' + global_data?.contact_data.phoneLine[0]
              : ''}
            {global_data?.email ? '- Email: ' + global_data?.email : ''}
          </Text>
          <Text style={{ fontSize: 7 }}> www.{global_data.domain}</Text>
        </View>
      </Page>
    </Document>
  )
}

export default DataTable
